
  
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}


function checkStock(sku){
  var cookie_location = getCookie("location");
  if($(cookie_location) != undefined){
    
    var sku_ = sku.replace("C","");
    var location_id = getCookie("location");
    var skus = new Array();
    skus.push(sku_);
    $.get("https://saborista.apps.bydas.com/index.php", {action:"get_stock_location2", sku:skus, location:location_id, store:0})
    .done(function(data){
      data = JSON.parse(data);

      if(data[sku_] == undefined || data[sku_]  <= 0 || data == "Error- Inventario n\u00e3o encontrado."){
    
        $("input[data-sku="+sku_+"]").addClass("sold_out");
        $(".variations_button.custom_bydas .custom_button_byydas_pr_addtc ").attr("type","button")
        $(".variations_button.custom_bydas .custom_button_byydas_pr_addtc ").removeClass("js_frm_cart")
        $(".variations_button.custom_bydas .custom_button_byydas_pr_addtc ").addClass("soldOut")
        $(".variations_button.custom_bydas .txt_add ").text("Esgotado")
        
      }

      if(Cookies.get("cp") == "Centro"){
        $(".VariantPacks").removeClass("d-none-packs")
        $(".VariantPacks").removeClass("d-none")
        
        $($($(".VariantPacks")[1]).find(".variant_label")[0]).trigger("click")
      }
      
      //$($(".plan_options .variant_label")[0]).trigger("click");
      
      VerifyVisibleTags();
    })
  }

}

function addTagSoldOut(){
    if($(".custom_button_byydas_pr_addtc").length > 0){
      	  $($(".custom_button_byydas_pr_addtc")[0]).attr("type", "button").removeClass("js_frm_cart").addClass("soldOut")[0].innerText = "Esgotado";  
    }
  	$(".row.plans").addClass("d-none");
  	$(".packs_label").addClass("d-none");
}

function ProcessStockCount(){
 	var SoldOutNr = 0;
    var VarAvailables = 0;
    $(".template-product .type_buy").each((key,item)=>{

            if($(item).find("input").hasClass("sold_out") && $(item).hasClass("d-none") == false){
              SoldOutNr++;
            }

            if($(item).hasClass("d-none") == false){
              VarAvailables++
            }
   })


  if(SoldOutNr == VarAvailables){
   addTagSoldOut();

  }else{
  	$(".type_buy").each((key,variant)=>{
      if($(variant).hasClass("d-none") == false && $(".type_buy").parent().find("input:checked").length == 0){
        $(variant).find("input").attr("checked", "checked");	
        $(variant).click();
      } 
      return;                    
    })
  }
  
}

function VerifyVisibleTags(){

  if(Cookies.get("ColaboratorPickUp") != undefined && Cookies.get("ColaboratorPickUp") == "armazem"){
    if($(".template-product #shopify-section-pr_summary_custom").find(".VariantColaborador").length == 0){
    	disableBuyBCWrongProfile();
      	return;
    }else{
     
      $(".template-product #shopify-section-pr_summary_custom .type_buy").addClass("d-none");
      $(".template-product #shopify-section-pr_summary_custom .type_buy.VariantColaborador").removeClass("d-none");
      ProcessStockCount();
    }
  }else{
    $(".template-product #shopify-section-pr_summary_custom .type_buy").removeClass("d-none");
    $(".template-product #shopify-section-pr_summary_custom .type_buy.VariantColaborador").addClass("d-none");
    ProcessStockCount();
  }
  
}

function disableBuyBCWrongProfile(){

	var  label = '<span class="wrong_profile">Produto disponível apenas para entrega em casa</div>';
    $(".row.plans").remove();
  	$(".variations_button").addClass("d-none");
    if($(".template-product").find(".wrong_profile").length == 0){
      $(label).insertBefore($(".variations_button"));
    }
  
}